import { render, staticRenderFns } from "./FullTextBatchReview.vue?vue&type=template&id=2c9b5264"
import script from "./FullTextBatchReview.vue?vue&type=script&lang=js"
export * from "./FullTextBatchReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports